import type { RowData } from "@tanstack/react-table";
import { Table, type TableProps } from "./Table";
import type { TablePaginationProps } from "./pagination";

export function TablePaginated<T extends RowData>(
  props: Pick<
    TableProps<T>,
    | "columns"
    | "data"
    | "onRowClick"
    | "noResultsText"
    | "paginationLabel"
    | "handleTableSort"
    | "columnSortName"
    | "roundedTop"
    | "gridClasses"
    | "initialOffset"
    | "setScrollOffset"
    | "pageSizeOptions"
    | "defaultPageSize"
  > &
    TablePaginationProps,
) {
  return <Table {...props} containedScroll />;
}
